export default __webpack_public_path__ + "static/media/chat-icon3.7e807b24.svg";